export const isEmailValid = (email) => {
  // Basic email format validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const sortObjectDesc = (obj, sortBy) => {
  let sortedObj = obj.sort(
    (a, b) => parseFloat(b[sortBy]) - parseFloat(a[sortBy])
  );
  return sortedObj;
};

export async function hashWithSHA256(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
